import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-base-template',
  imports: [],
  templateUrl: './base-template.html',
  styleUrl: './base-template.scss',
})
export class BaseTemplate {
  kinomapAppstoreUrl: string = environment.external_links.kinomap_appstore;
  kinomapPlaystoreUrl: string = environment.external_links.kinomap_playstore;
  kinomapUrl: string = environment.external_links.kinomap;
}
